<template>
  <f7-page no-toolbar no-swipeback name="integral" class="page-integral" @page:init="onPageInit">
    <f7-navbar innerClass="navbar-inner-message" back-link :no-hariline="true">
      <f7-nav-title>{{ $t("integral_0001") }}</f7-nav-title>
      <f7-nav-right >
        <img @click="$f7router.navigate('/integral-recordss/')" src="../../static/images/yt999/newss/integral/records.png" style="width: 18px;margin-right: 12px;" />
      </f7-nav-right>
    </f7-navbar>

    <div class="integral-wrap">
      <div class="integral-header">
        <div class="header-content">
          <div class="points-title">{{ $t("integral_0002") }}</div>
          <div class="points-value" @click="$f7router.navigate('/member-center/integral-search/')">
            {{ userInfo.BonusPoint  | formatCurrency2}}
            <span class="points-unit">{{ $t("integral_0003") }}</span>
            <i class="f7-icons" style="font-size: 18px;">chevron_right</i>
          </div>
          <div class="vip-badge" v-if="userInfo && userInfo.VipLevelName">
            <img src="../../static/images/yt999/newss/integral/ok.png" class="vip-icon" alt="vip" />
            <span>{{ $t("integral_0010") }}</span>&nbsp;<span>{{ userInfo.VipLevelName }}</span>
          </div>
          <div class="vip-badge vip-badge2" v-if="userInfo && userInfo.VipLevelName" @click="openRule()">
            <img src="../../static/images/yt999/newss/integral/gz.png" class="vip-icon" alt="vip" />
            <span>{{ $t("luckbox_022") }}</span>
          </div>
        </div>
      </div>

      <div class="tab-panel">
        <van-tabs v-model="activeTab" class="integral-tabs" animated>
          <van-tab :title="$t('integral_0004')">
            <div v-if="show1==1" class="goods-list">
              <div class="goods-item" v-for="item in physicalGoods" :key="item.BonusPointGoodsID">
                <div style="display: flex;">
                  <div class="goods-img-wrap">
                    <img class="goods-img" :src="item.ItemImageFileName" :onerror="`this.onerror='';this.src='${defaultGoodsImg}'`"/>
                  </div>
                  <div class="goods-body">
                    <div class="goods-name">{{ item.BonusPointGoodsName || '--' }}</div>
                    <div class="goods-price">{{ item.Price  | formatCurrency2}} {{ $t("integral_0003") }}</div>
                    <button class="redeem-btn" v-if="!item.OutOfStock" @click="confirmRedeem(item)">{{ $t("integral_0006") }}</button>
                    <button class="redeem-btn locked" v-else >{{ $t("integral_0011") }}</button>
                  </div>
                </div>

                <div class="goods-body">
                  <div class="eligibility" v-if="item.VIPLevelLimitList.length>0">
                    <div class="eligibility-label">{{ $t("integral_0007") }}</div>
                    <div class="vip-tags">
                      <span class="vip-tag" :class="{ locked: item.OutOfStock }" v-for="(vipName, idx) in item.VIPLevelLimitList" :key="idx">
                        {{ vipName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="show1==2" class="no-data">
              <img
                :src="`../../static/images/yt999/noData_${$f7.params.currLang}.png`"
                :onerror="`this.onerror='';this.src='../../static/images/yt999/noData_enUS.png'`"
                alt="no-data"
              />
            </div>
          </van-tab>

          <van-tab :title="$t('integral_0005')">
            <div v-if="show2==1" class="goods-list">
              <div class="goods-item" v-for="item in cashGoods" :key="item.BonusPointGoodsID">
                <div style="display: flex;">
                  <div class="goods-img-wrap">
                    <img class="goods-img" :src="item.ItemImageFileName" :onerror="`this.onerror='';this.src='${defaultGoodsImg}'`"/>
                  </div>
                  <div class="goods-body">
                    <div class="goods-name">{{ item.BonusPointGoodsName || '--' }}</div>
                    <div class="goods-price">{{ item.Price  | formatCurrency2}} {{ $t("integral_0003") }}</div>
                    <button class="redeem-btn" v-if="!item.OutOfStock" @click="confirmRedeem(item)">{{ $t("integral_0006") }}</button>
                    <button class="redeem-btn locked" v-else >{{ $t("integral_0011") }}</button>
                  </div>
                </div>

                <div class="goods-body">
                  <div class="eligibility" v-if="item.VIPLevelLimitList.length>0">
                    <div class="eligibility-label">{{ $t("integral_0007") }}</div>
                    <div class="vip-tags">
                      <span class="vip-tag" :class="{ locked: item.OutOfStock }" v-for="(vipName, idx) in item.VIPLevelLimitList" :key="idx">
                        {{ vipName }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="show2==2" class="no-data">
              <img
                :src="`../../static/images/yt999/noData_${$f7.params.currLang}.png`"
                :onerror="`this.onerror='';this.src='../../static/images/yt999/noData_enUS.png'`"
                alt="no-data"
              />
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="dialog dialog-tan" id="tan" >
      <div class="tan">
        <div class="tan-header">
          <img class="tan-alert-icon" src="../../static/images/yt999/newss/integral/jg.png" alt="alert" />
          <div class="tan-title">{{ $t("integral_0012") }}</div>
        </div>
        <div class="tan-desc" v-html="$t('integral_0013', [activepoints.Price ])"></div>
        <div class="tan-card">
          <div class="tan-thumb-wrap">
            <img
              class="tan-thumb"
              :src="activepoints.ItemImageFileName"
              :onerror="`this.onerror='';this.src='${defaultGoodsImg}'`"
              alt="goods"
            />
          </div>
          <div class="tan-info">
            <div class="tan-label">{{ $t("integral_0014") }}</div>
            <div class="tan-name">{{ activepoints.BonusPointGoodsName || '--' }}</div>
          </div>
        </div>
        <div class="btn">
          <button type="button" class="btn-item btn-cancel" @click="closeRedeemDialog">{{ $t("common_0002") }}</button>
          <button type="button" class="btn-item btn-confirm" @click="submitRedeem">{{ $t("common_0001") }}</button>
        </div>
      </div>


    </div>

    <div class="dialog ruledialog">
      <div class="dialog-inner">
        <div class="dialog-title" style="height: 35px; line-height: 35px">
          <h5>{{ $t("luckbox_022") }}</h5>
        </div>
        <div class="dialog-text">
          <f7-block class="block-message">
            <div class="block-content" v-html="websiteinfoGet.BonusPointRulesRemark||'--'" style="height: 350px"></div>
            <f7-block-footer>
              <f7-row no-gap>
                <f7-col tag="span">
                  <f7-button large class="btn-next border-radius-left" @click="closeRule()">{{ $t("common_0001") }}</f7-button>
                </f7-col>
              </f7-row>
            </f7-block-footer>
          </f7-block>
        </div>
      </div>
    </div>
  </f7-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getUserInfo, getBonusPointGoodInfoList, memberBonusPointExchangeSubmit, getwebsiteinfoGet } from "../../axios/api";

export default {
  name: "Integral",
  data() {
    return {
      btnflag: true,
      goodsList: [],
      activeTab: 0,
      defaultGoodsImg: "../../static/images/yt999/newss/integral/ok.png",
      activepoints:{},
      show1:0,
      show2:0,
      userInfo: { BonusPoint: 0, VipLevelName: '' },
      websiteinfoGet: {},
    };
  },
  computed: {
    physicalGoods() {
      return this.goodsList.filter((item) => item.BonusPointGoodsType == 'PhysicalPrizes');
    },
    cashGoods() {
      return this.goodsList.filter((item) => item.BonusPointGoodsType == 'BonusPointToBalance');
    },

  },
  methods: {
    onPageInit() {
      this.getBonusPointGoodInfoList();
      this.getwebsiteinfoGet(); 
    },
    getwebsiteinfoGet(){
      getwebsiteinfoGet().then((data) => {
        if (data.Code === "NoError") {
          this.websiteinfoGet = data.Data;
        }
      });
    },
    openRule() {
      this.$f7.params.dialog.closeByBackdropClick = true; //点击背景关闭
      this.$f7.dialog.open(".ruledialog", true);
    },
    closeRule() {
      this.$f7.dialog.close(".ruledialog");
    },
    getBonusPointGoodInfoList(){
      getBonusPointGoodInfoList().then((data) => {
        if (data.Code === "NoError") {
          this.goodsList = data.Data;
          if (this.goodsList.some(item => item.BonusPointGoodsType === 'PhysicalPrizes')) {
            this.show1 = 1;
          }else{
            this.show1 = 2;
          }
          if (this.goodsList.some(item => item.BonusPointGoodsType === 'BonusPointToBalance')) {
            this.show2 = 1;
          }else{
            this.show2 = 2;
          }
        }
      });
    },
    getUserInfo() {
      getUserInfo().then((data) => {
        if (data.Code === "NoError") {
          this.userInfo = data.Data;  
        }
      });
    },
    confirmRedeem(item) {
      this.activepoints = item;
      this.$f7.dialog.open("#tan", true);
    },
    closeRedeemDialog() {
      this.$f7.dialog.close("#tan");
    },
    submitRedeem() {
      this.closeRedeemDialog();
      this.doRedeem(this.activepoints);
    },
    doRedeem(item) {
      if (!item || !item.BonusPointGoodsID) return;
      if (!this.btnflag) return;
      this.btnflag = false; 

      const param = {
        data: JSON.stringify({ BonusPointGoodsID: item.BonusPointGoodsID }),
      };
      memberBonusPointExchangeSubmit(param).then((res) => {
        this.$f7.dialog.alert(res.Data, this.$t('common_0004'));
        this.btnflag = true; 
        if (res.Code === "NoError") {
          this.getUserInfo();
        }
        
      });
    },
  },
  created() {
    this.getUserInfo();
  },  
};
</script>

<style lang="less" scoped>
/deep/ .page-content{
    background: #f7f9fb;
}
.page-integral {
  



  .integral-wrap {
    padding: 12px;
  }

  .integral-header {
    border-radius: 12px;
    background: var(--f7-THEME-color);
    padding: 20px;
    margin-bottom: 14px;

    .points-title {
      color: rgba(255, 255, 255, 0.9);
      font-size: 11px;
      letter-spacing: 1px;
      font-weight: 600;
      margin-bottom: 8px;
      text-transform: uppercase;
    }

    .points-value {
      color: #fff;
      font-size: 28px;
      line-height: 1;
      font-weight: 800;
      margin-bottom: 14px;

      .points-unit {
        font-size: 24px;
        margin-left: 6px;
        opacity: 0.95;
      }
    }

    .vip-badge {
      display: inline-flex;
      align-items: center;
      padding: 6px 12px;
      border-radius: 999px;
      background: #528b9e;
      color: #fff;
      font-size: 11px;
      font-weight: 700;

      .vip-icon {
        width: 14px;
        height: 14px;
        margin-right: 6px;
      }
    }
    .vip-badge2 {
      position: absolute;
      right: 32px;
    }
  }

  .tab-panel {
    border-radius: 12px;
    background: transparent;
  }

  .integral-tabs {
    /deep/ .van-tabs__nav {
      padding: 0;
      border-radius: 7px;
      background: none;
    }
    /deep/ .van-tabs__wrap {
      border-radius: 9px;
      overflow: hidden;
      background: #eceef0;
      margin-bottom: 12px;
      height: 38px;
      padding: 5px;
      
    }

    /deep/ .van-tab {
      font-size: 13px;
      font-weight: 700;
      color: #535c6f;
      text-transform: uppercase;
    }

    /deep/ .van-tab--active {
      color: var(--f7-THEME-color);
      background: #ffffff;
      border-radius: 7px;
    }

    /deep/ .van-tabs__line {
      display: none;
    }
  }

  .goods-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .goods-item {
    border-radius: 12px;
    background: #fff;
    border: 1px solid rgba(166, 166, 166, 0.1);
    padding: 12px;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);

    .goods-img-wrap {
      width: 78px;
      height: 78px;
      border-radius: 10px;
      background: #ececef;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      flex-shrink: 0;
      margin-right: 12px;

      .goods-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .goods-body {
      flex: 1;
      min-width: 0;
      .locked{
        background: #e6e9eb!important;
        color: #7b7373!important;
      }
    }

    .goods-name {
      color: #1f2128;
      font-size: 15px;
      font-weight: 700;
      line-height: 1.25;
      word-break: break-word;
    }

    .goods-price {
      color: var(--f7-THEME-color);
      font-weight: 800;
      margin-bottom: 8px;
    }

    .redeem-btn {
        border: none;
        outline: none;
        border-radius: 7px;
        padding: 6px 14px;
        color: #fff;
        background: var(--f7-THEME-color);
        font-size: 12px;
        font-weight: 700;
        // text-transform: uppercase;
        margin-bottom: 9px;
        width: 75%;
    }


    .eligibility {
      border-top: 1px solid #d9dce2;
      padding-top: 8px;
      margin-top: 2px;
    }

    .eligibility-label {
      color: #9da3b2;
      font-size: 12px;
      font-weight: 700;
      margin-bottom: 6px;
      text-transform: uppercase;
    }

    .vip-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

      .vip-tag {
        background: #eaf1ff;
        color: var(--f7-THEME-color);
        border: 1px solid #d4d4d4;
        border-radius: 4px;
        font-size: 10px;
        font-weight: 700;
        line-height: 1;
        padding: 4px 8px;
      }
    }
  }

  .no-data {
    padding: 28px 10px;
    display: flex;
    justify-content: center;

    img {
      width: 62%;
      max-width: 280px;
    }
  }


}
.ruledialog {
  width: 86%;
  margin: 0 7%;
  background-color: white !important;
  left: 0;

  .dialog-inner {
    padding: 0;
    text-align: left;

    .dialog-title {
      text-align: center;
      position: relative;
      font-size: 18px;
      padding-bottom: 4px;
      h3 {
        margin: 0 0 2px 0;
      }

      h5 {
        margin: 0;
        font-weight: normal;
      }
    }

    .dialog-title:after {
      content: "";
      position: absolute;
      z-index: 1;
      background: url(../../static/images/yt999/light.png) no-repeat;
      background-size: var(--f7-size-percent-100) var(--f7-size-percent-100);
      height: var(--f7-height-size-2);
      width: 100%;
      display: block;
      top: auto;
      right: auto;
      bottom: 0;
      left: 0;
      transform-origin: 50% 100%;
      transform: scaleY(1);
      transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
    }

    .dialog-text {
      .block-message {
        margin: var(--f7-margin-size-0);
        padding: var(--f7-padding-size-0);
        width: var(--f7-width-size-pt100);

        .block-content {
          padding: var(--f7-padding-size-8) var(--f7-padding-size-10);
          height: 300px;
          overflow: hidden scroll;
          font-size: 15px;
          background:white;
        }

        .row-toggle {
          margin: 10px 10px 0;

          span {
            color: var(--f7-dialog-button-text-color-right);
          }

          .toggle {
            margin-top: var(--f7-margin-size-f2);
          }
        }

        .block-footer {
          margin-top: 8px;

          .row.no-gap {
            --f7-grid-gap: 0px;
          }

          .button {
            height: 50px;
            line-height: 50px;
            color: var(--f7-color-white);
            font-size: var(--f7-px-16);
          }

          .btn-next {
            background: var(--f7-dialog-button-bg-color-right);
            color: var(--f7-dialog-button-text-color-right);
          }

          .btn-next.button-disabled {
            opacity: 0.6;
            // color: var(--f7-dialog-button-text-disable-color-right) !important;
          }

          .btn-close {
            background-color: var(--f7-dialog-button-bg-color-left);
            color: var(--f7-dialog-button-text-color-left);
            border-radius: 0;
          }
        }
      }
    }
  }
}
</style>